export type ToastItem = {
	id: number;
	message: string;
	type: 'success' | 'error' | 'warning' | 'info';
	autoDismiss?: boolean;
	duration?: number;
};

type ToastInput = Omit<ToastItem, 'id'>;

class ToastState {
	items = $state<Array<ToastItem>>([]);

	private nextId = 0;

	private push(toast: ToastInput) {
		const id = ++this.nextId;
		this.items = [...this.items, { ...toast, id }];
		return id;
	}

	remove(id: number) {
		this.items = this.items.filter((t) => t.id !== id);
	}

	success(message: string) {
		return this.push({ message, type: 'success' });
	}

	error(message: string) {
		return this.push({ message, type: 'error' });
	}

	warning(message: string) {
		return this.push({ message, type: 'warning' });
	}

	info(message: string) {
		return this.push({ message, type: 'info' });
	}
}

export const toast = new ToastState();

export const showSuccess = (message: string) => toast.success(message);
export const showError = (message: string) => toast.error(message);
export const showWarning = (message: string) => toast.warning(message);
export const showInfo = (message: string) => toast.info(message);
